import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const ProfileSection = ({ title, description, className, children }) => {
    return (
        <div className={cn("flex w-full flex-col gap-3", className)}>
            <div className="flex flex-col gap-1">
                <h4 className="text-xs font-medium uppercase text-cm-p-text-secondary">
                    <TranslatedText>{title}</TranslatedText>
                </h4>
                {description && (
                    <p className="text-xs text-cm-p-text-secondary">
                        <TranslatedText>{description}</TranslatedText>
                    </p>
                )}
            </div>
            {children}
        </div>
    );
};
